{
  "name": "memas-adminweb",
  "version": "1.7.5",
  "author": "Erlend Øverby <erlend.overby@karde.no>",
  "license": "NA",
  "repository": "https://github.com/Hypatia-Learning/memas-bruker.git",
  "type": "module",
  "scripts": {
    "build": "NODE_ENV=production VITE_NODE_ENV=production vite build --mode production",
    "stage": "NODE_ENV=stage vite build --mode stage",
    "lint": "eslint . --fix",
    "dev": "vite",
    "preview": "vite preview",
    "server": "vite dev --host localhost --port 8200 --mode development",
    "httpsserver": "vite dev --config vite.config.https.js --host localhost --port 8200 --mode development"
  },
  "engines": {
    "node": ">= 24"
  },
  "dependencies": {
    "@azure/msal-browser": "~4",
    "@ckeditor/ckeditor5-clipboard": "~43",
    "@ckeditor/ckeditor5-core": "~43",
    "@ckeditor/ckeditor5-engine": "~43",
    "@ckeditor/ckeditor5-enter": "~43",
    "@ckeditor/ckeditor5-paragraph": "~43",
    "@ckeditor/ckeditor5-select-all": "~43",
    "@ckeditor/ckeditor5-typing": "~43",
    "@ckeditor/ckeditor5-ui": "~43",
    "@ckeditor/ckeditor5-undo": "~43",
    "@ckeditor/ckeditor5-upload": "~43",
    "@ckeditor/ckeditor5-utils": "~43",
    "@ckeditor/ckeditor5-vue": "~7",
    "@ckeditor/ckeditor5-widget": "~43",
    "@fullcalendar/vue3": "~7",
    "@fullcalendar/vue3-scheduler": "^7.1.3",
    "@intlify/unplugin-vue-i18n": "~11",
    "@vite-pwa/assets-generator": "~2",
    "@webspellchecker/wproofreader-ckeditor5": "~3",
    "buffer": "~6",
    "chart.js": "~4",
    "chartjs-adapter-dayjs-4": "~1",
    "ckeditor5": "~43",
    "compressorjs": "~1",
    "dayjs": "~1",
    "dompurify": "~3",
    "glob": "~13",
    "google-auth-library": "~11",
    "jose": "~6",
    "jsonwebtoken": "^9.0.3",
    "marked": "~18",
    "pinia": "~4",
    "pinia-plugin-persistedstate": "^4.7.1",
    "simple-vue-camera": "~1",
    "temporal-polyfill": "^1.0.6",
    "uuid": "~14",
    "video.js": "~10",
    "vidstack": "^1.15.7",
    "vite-plugin-vuetify": "^2.1.3",
    "vue": "~3",
    "vue-advanced-cropper": "~2",
    "vue-chartjs": "~5",
    "vue-draggable-next": "~2",
    "vue-i18n": "~11",
    "vue-router": "~5",
    "vue3-google-login": "~2",
    "vue3-spinner": "^0.0.17",
    "vue3-timepicker": "^1.0.0-beta.2",
    "vue3-toastify": "~0",
    "vuedraggable": "^4.1.0",
    "vuetify": "~4",
    "workbox-window": "~7"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@intlify/eslint-plugin-vue-i18n": "~4",
    "@intlify/unplugin-vue-i18n": "~11",
    "@mdi/font": "~7",
    "@rollup/plugin-inject": "~5",
    "@rushstack/eslint-patch": "~1",
    "@vitejs/plugin-vue": "~6",
    "@vue/eslint-config-prettier": "~10",
    "eslint": "~10",
    "eslint-plugin-vue": "~10",
    "postcss": "~8",
    "postcss-nested": "~9",
    "prettier": "~3",
    "sass": "~1",
    "typescript": "~7",
    "vite": "~8",
    "vite-plugin-node-polyfills": "~0",
    "vite-plugin-pwa": "~2",
    "vite-plugin-remove-console": "~2",
    "vite-svg-loader": "~5",
    "vue-eslint-parser": "~10"
  },
  "lint-staged": {
    "*.{vue,js,ts,jsx,tsx}": "prettier --check"
  },
  "prettier": {
    "semi": false,
    "singleQuote": true,
    "trailingComma": "none"
  },
  "eslintConfig": {
    "root": true,
    "extends": [
      "eslint:recommended",
      "plugin:vue/vue3-essential",
      "plugin:vue/vue3-strongly-recommended",
      "plugin:@intlify/vue-i18n/recommended",
      "plugin:vue/vue3-recommended"
    ],
    "parser": "vue-eslint-parser",
    "parserOptions": {
      "ecmaVersion": "latest"
    },
    "settings": {
      "vue-i18n": {
        "localeDir": "@/i18n/lang/*.json",
        "messageSyntaxVersion": "~10"
      }
    },
    "rules": {
      "@intlify/vue-i18n/no-dynamic-keys": "warn",
      "@intlify/vue-i18n/no-unused-keys": [
        "warn",
        {
          "extensions": [
            ".json",
            ".vue"
          ]
        }
      ],
      "semi": [
        2,
        "never"
      ],
      "vue/script-setup-uses-vars": 0,
      "no-prototype-builtins": 1,
      "vue/max-attributes-per-line": [
        "warn",
        {
          "singleline": {
            "max": 2
          },
          "multiline": {
            "max": 2
          }
        }
      ],
      "vue/first-attribute-linebreak": [
        "warn",
        {
          "singleline": "ignore",
          "multiline": "below"
        }
      ],
      "vue/no-v-html": 0,
      "vue/no-v-text-v-html-on-component": "warn",
      "quotes": [
        "warn",
        "single",
        {
          "avoidEscape": true,
          "allowTemplateLiterals": true
        }
      ],
      "comma-dangle": [
        "warn",
        {
          "arrays": "never",
          "objects": "never",
          "imports": "ignore",
          "exports": "ignore",
          "functions": "never"
        }
      ],
      "no-undef": [
        "warn"
      ],
      "no-unused-vars": [
        "warn"
      ]
    }
  },
  "packageManager": "yarn@4.18.1"
}
